import { useEffect, useState, useRef } from "react";

const TIER_LABEL = {
  trial: "started the 7-Day Trial 🎟️",
  monthly: "unlocked Monthly Premium 🥇",
  yearly: "unlocked Yearly Premium 👑",
};

export default function BullhornBanner() {
  const [queue, setQueue] = useState([]);
  const [current, setCurrent] = useState(null);
  const dismissTimer = useRef(null);

  // Listen for global premium-unlock broadcasts
  useEffect(() => {
    function onUnlock(e) {
      const detail = e.detail || {};
      setQueue((q) => [
        ...q,
        {
          id: Date.now() + Math.random(),
          userName: detail.userName || "An athlete",
          packageId: detail.packageId || "monthly",
        },
      ]);
    }
    window.addEventListener("omni:premium-unlock", onUnlock);
    return () => window.removeEventListener("omni:premium-unlock", onUnlock);
  }, []);

  // Pull from queue
  useEffect(() => {
    if (current || queue.length === 0) return;
    const next = queue[0];
    setQueue((q) => q.slice(1));
    setCurrent(next);
    if (dismissTimer.current) clearTimeout(dismissTimer.current);
    dismissTimer.current = setTimeout(() => setCurrent(null), 10000); // 10s visible
  }, [queue, current]);

  if (!current) return null;

  const action = TIER_LABEL[current.packageId] || "joined the Inner Circle 🥇";
  const announcement = `🎺  ${current.userName} just ${action}  ·  Welcome to the Phoenix family  ·  `;

  return (
    <div
      data-testid="bullhorn-banner"
      className="fixed top-0 left-0 right-0 z-[100] bg-gradient-to-r from-[#4C1D95] via-[#D4AF37] to-red-600 text-[#0A0A0A] overflow-hidden border-b-2 border-[#0A0A0A] shadow-2xl"
      style={{ animation: "bullhornDrop 0.5s ease-out" }}
    >
      <div className="relative whitespace-nowrap py-3 font-bold uppercase tracking-widest text-sm">
        <div
          style={{
            display: "inline-block",
            paddingLeft: "100%",
            animation: "bullhornScroll 10s linear forwards",
          }}
        >
          {/* repeat the announcement so the marquee stays full */}
          {announcement}{announcement}{announcement}
        </div>
        <button
          onClick={() => setCurrent(null)}
          aria-label="Dismiss"
          className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center bg-[#0A0A0A] text-[#D4AF37] hover:bg-[#1a1a1a] text-xs font-bold"
          data-testid="bullhorn-dismiss"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
